export default __webpack_public_path__ + "static/media/ic_fullscreen.c1d7c6f0.svg";